import { VetologyBase } from '../Vetology/VetologyBase';

export class ShareCase extends VetologyBase
{
    constructor ()
    {
        super('ShareCase');

        this.clinicSearchTimeout = null;
    }

    init ()
    {
        const _self = this;

        setTimeout(() => {
            _self.initEventHandlers()
        }, 200);

    }

    initEventHandlers ()
    {
        const _self = this

        _self.clinicSearch = _self.clinicSearch.bind(_self);
        const clinicSearchElement = document.querySelector('.caseShareClinicSearch');
        clinicSearchElement.addEventListener('keyup', _self.clinicSearch);

        _self.clinicSearchChanged = _self.clinicSearchChanged.bind(_self);
        $("body").on('change', ".clinicSelectorShare", _self.clinicSearchChanged);

        _self.saveInternalShare = _self.saveInternalShare.bind(_self);
        const shareButtons = document.querySelectorAll('tbody.distribution_table a.save_internal');
        shareButtons.forEach(btn => {
            btn.addEventListener('click', _self.saveInternalShare);
        });

        _self.removeInternalShare = _self.removeInternalShare.bind(_self);
        const removeButtons = document.querySelectorAll('tbody.distribution_table a.remove_from_share_internal');
        removeButtons.forEach(btn => {
            btn.addEventListener('click', _self.removeInternalShare);
        });

        _self.saveAllInternal = _self.saveAllInternal.bind(_self);
        const saveAllInternalBtn = document.querySelector('#internal-share-btn');
        saveAllInternalBtn.addEventListener('click', _self.saveAllInternal);

        document.addEventListener('post-do-request-event', function (event) {
            window.location.reload();
        });
    }

    removeEventHandlers ()
    {
        const _self = this

        const clinicSearchElement = document.querySelector('.caseShareClinicSearch');
        clinicSearchElement.removeEventListener('keyup', _self.clinicSearch);

        const shareButtons = document.querySelectorAll('tbody.distribution_table a.save_internal');
        shareButtons.forEach(btn => {
            btn.removeEventListener('click', _self.saveInternalShare);
        });

        const removeButtons = document.querySelectorAll('tbody.distribution_table a.remove_from_share_internal');
        removeButtons.forEach(btn => {
            btn.removeEventListener('click', _self.removeInternalShare);
        });

        const saveAllInternalBtn = document.querySelector('#internal-share-btn');
        saveAllInternalBtn.removeEventListener('click', _self.saveAllInternal);
    }

    clinicSearch(event)
    {
        const _self = this;

        event.preventDefault();
        event.stopPropagation();
        clearTimeout(_self.clinicSearchTimeout);
        const target = event.target;
        const clinicName = target.value;
        if (clinicName.length < 2) {
            return;
        }
        const form = target.closest('form.internal-shares');
        const span = document.createElement('span');
        span.classList.add('searching', 'vetology-loop', 'spin2');
        const p = target.closest('.searchFieldWrap');
        const children = p.querySelectorAll('.searching');
        if (children.length > 0) {
            children.forEach(elem => {
                elem.remove();
            });
        }
        const clinicSelector =form.querySelector('.clinicSelectorShare');
        clinicSelector.innerHtml = '';
        p.classList.add('searching');
        p.append(span);
        clinicSelector.dataset.placeholder = "Searching for clinics matching the name '" +  clinicName + "'";
        $(clinicSelector).select2();

        _self.clinicSearchTimeout = setTimeout(() => {
            fetch("/worklist/specialty-hospital/one-click-referrals-reviewed/distribute?clinic=" + clinicName, {
                method: 'get',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(response => {
                if (response.ok) {
                    response.json().then(data => {
                        p.classList.remove('searching');
                        const children = p.querySelectorAll('.searching');
                        children.forEach(elem => {
                            elem.remove();
                        });
                        console.log(data);
                        if (data.length > 0) {
                            const option = document.createElement('option');
                            option.textContent = 'Select the clinic that you would like to distribute the case to from below';
                            option.selected = true;
                            option.attributes.disabled = true;
                            clinicSelector.appendChild(option);
                            for (const [id, clinic] of Object.entries(data.records)) {
                                const option =document.createElement('option');
                                option.value = id;
                                option.textContent = clinic;
                                clinicSelector.appendChild(option);
                            }
                            clinicSelector.dataset.placeholder = "Select the clinic that you like to distribute the case to";
                            $(clinicSelector).select2();
                        } else {
                            clinicSelector.dataset.placeholder = "No clinics found with the search criteria";
                            $(clinicSelector).select2();
                        }
                        $(clinicSelector).select2({
                            width: '100%'
                        });
                    });
                }
            });
        });
    }

    saveInternalShare(event)
    {
        event.preventDefault();
        event.stopPropagation();

        const target = event.target;
        target.textContent = ' Saving Changes';
        const tr = target.closest('tr');
        const clinicData = tr.dataset.clinic;
        tr.classList.add('warning');
        const form = target.closest('form');
        const formData = new FormData();
        formData.set('clinic', clinicData);
        formData.set('email_distro', tr.querySelector('input[name="email_distro"]').checked);
        formData.set('share_distro', tr.querySelector('input[name="share_distro"]').checked);
        formData.set('fax_distro', tr.querySelector('input[name="fax_distro"]').checked);
        formData.set('docs_distro', tr.querySelector('input[name="docs_distro"]').checked);
        formData.set('images_distro', tr.querySelector('input[name="images_distro"]').checked);
        formData.set('prescriptions_distro', tr.querySelector('input[name="prescriptions_distro"]').checked);
        formData.set('lab_panels_distro', tr.querySelector('input[name="lab_panels_distro"]').checked);
        formData.set('appointments_distro', tr.querySelector('input[name="appointments_distro"]').checked);
        formData.set('summary_keyword', tr.querySelector('input[name="summary_keyword"]').value);
        formData.set('action', 'updateDistro');
        formData.set('case', form.querySelector('#ocrcId').value);

        fetch('/worklist/specialty-hospital/one-click-referrals-reviewed/distribute', {
            method: 'post',
            body: formData,
            expects: 'json'
        }).then(response => {
            if (response.ok) {
                response.json().then(data => {
                    if (data.success) {
                        toastr.success('Successfully saved changes');
                        tr.classList.remove('warning');
                        target.textContent = '';
                    } else {
                        toastr.error(data.error);
                    }
                })
            } else {
                toastr.error('Could not save changes at this time. Please try later.');
            }
        })

    }

    removeInternalShare(event)
    {
        event.preventDefault();
        event.stopPropagation();
        const target = event.target;
        const tr = target.closest('tr');
        const clinicID = tr.dataset.clinic;
        tr.classList.add('warning');
        const formData = new FormData;
        const caseElem = document.querySelector('#ocrcId');

        formData.append('clinic', clinicID);
        formData.append('action', 'removeDistro');
        formData.append('case', caseElem.value);
        fetch('/worklist/specialty-hospital/one-click-referrals-reviewed/distribute', {
            method: 'post',
            body: formData,
            expects: 'json'
        }).then(result => {
            if (result.ok) {
                result.json().then(data => {
                    if (data.success) {
                        toastr.success('Successfully removed distribution');
                        tr.classList.remove('warning');
                        tr.remove();
                    } else {
                        toastr.error(data.error);
                    }
                });

            } else {
                toastr.error('Could not remove distribution at this time');
            }
        });
    }

    clinicSearchChanged(event)
    {
        const _self = this;
        const target = event.target;
        if (target.tagName !== 'SELECT' && target.classList.contains('clinicSelectorShare')) {
            return;
        }
        event.stopPropagation();
        event.preventDefault();

        const distributionTable = document.querySelector('.distribution_table');
        const selectedClinic = target.querySelector('option:checked');
        if (!selectedClinic) {
            return;
        }
        const existing = distributionTable.querySelector('tr.clinic_' + selectedClinic.value);
        if (existing) {
            return;
        }

        const tr = document.createElement('tr');
        tr.dataset.clinic = selectedClinic.value;
        tr.classList.add('warning', 'clinic_' + selectedClinic.value);
        let html = ("<td>" + selectedClinic.innerHTML + "</td>");
        html += ("<td><input value=\"1\" name=\"email_distro\" type=\"checkbox\" checked></td>");
        html += ("<td><input value=\"1\" name=\"fax_distro\" type=\"checkbox\" checked ></td>");
        html += ("<td><input value=\"1\" name=\"share_distro\" type=\"checkbox\" checked></td>");
        html += ("<td><input value=\"1\" name=\"docs_distro\" type=\"checkbox\" checked></td>");
        html += ("<td><input value=\"1\" name=\"images_distro\" type=\"checkbox\" checked></td>");
        html += ("<td><input value=\"1\" name=\"prescriptions_distro\" type=\"checkbox\"></td>");
        html += ("<td><input value=\"1\" name=\"lab_panels_distro\" type=\"checkbox\"></td>");
        html += ("<td><input value=\"1\" name=\"appointments_distro\" type=\"checkbox\"></td>");
        html += ("<td style=\"min-width: 200px\"><input value=\"\" name=\"summary_keyword\" type=\"text\" class=\"form-control\" placeholder=\"Summary on keyword\"></td>");
        html += ("<td><a href='javascript:void(0)' class=\"save_internal fa vetology-save-as\"></a></td>");
        html += ("<td><a href='javascript:void(0)' class=\"remove_from_share_internal vetology-delete\"></a></td>");
        tr.innerHTML = html;
        const saveBtn = tr.querySelector('a.save_internal');
        saveBtn.addEventListener('click', _self.saveInternalShare);
        const removeBtn = tr.querySelector('a.remove_from_share_internal');
        removeBtn.addEventListener('click', _self.removeInternalShare);
        distributionTable.appendChild(tr);
        const ocrid = document.querySelector('#ocrcId');
        const formData = new FormData();
        formData.append('clinic', selectedClinic.value);
        formData.append('action', 'setDistro');
        formData.append('case', ocrid.value);

        fetch('/worklist/specialty-hospital/one-click-referrals-reviewed/distribute', {
            method: 'post',
            body: formData,
            accept: 'json'
        }).then(response => {
            if (response.ok) {
                response.json().then(data => {
                   if (data.success) {
                       toastr.success('Initialized distribution for this clinic');
                       tr.classList.remove('warning');
                   } else {
                       toastr.error(data.error);
                   }
                });
            } else {
                toastr.error('Could not initialize distribution at this time');
            }
        });
    }

    saveAllInternal(event)
    {
        event.preventDefault();
        event.stopPropagation();
        const rowSaveLinks = document.querySelectorAll('tbody.distribution_table tr a.save_internal');
        rowSaveLinks.forEach((link) => {
            const mouseEvent = new MouseEvent('click', {
                bubbles: false
            });
            link.dispatchEvent(mouseEvent);
        });

    }
}